/**
 * Utilitário central de CNPJ com suporte a formato alfanumérico.
 * Algoritmo de DV baseado em valor = ASCII(char) - 48.
 *
 * AB#333564 - RN06, RN07.
 */
export var CNPJ_REGEX = /^[0-9A-Z]{12}[0-9]{2}$/;
var CNPJ_LENGTH = 14;
export function normalize(cnpj) {
    if (!cnpj)
        return '';
    return cnpj.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}
export function charValue(c) {
    return c.charCodeAt(0) - 48;
}
export function calcDigitoVerificador(base) {
    var soma = 0;
    var peso = 2;
    for (var i = base.length - 1; i >= 0; i--) {
        soma += charValue(base.charAt(i)) * peso;
        peso = peso === 9 ? 2 : peso + 1;
    }
    var resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
}
export function isValidFormat(cnpj) {
    return !!cnpj && CNPJ_REGEX.test(cnpj);
}
export function isValid(cnpj) {
    var normalized = normalize(cnpj);
    if (!isValidFormat(normalized))
        return false;
    if (isSameCharRepeated(normalized))
        return false;
    var base12 = normalized.substring(0, 12);
    var dv1 = calcDigitoVerificador(base12);
    var dv2 = calcDigitoVerificador(base12 + dv1);
    var dvEsp1 = parseInt(normalized.charAt(12), 10);
    var dvEsp2 = parseInt(normalized.charAt(13), 10);
    return dv1 === dvEsp1 && dv2 === dvEsp2;
}
function isSameCharRepeated(s) {
    return s.length > 0 && s.split('').every(function (c) { return c === s.charAt(0); });
}
export function format(cnpj) {
    var normalized = normalize(cnpj);
    if (normalized.length !== CNPJ_LENGTH) {
        return cnpj !== null && cnpj !== void 0 ? cnpj : '';
    }
    return "".concat(normalized.substring(0, 2), ".").concat(normalized.substring(2, 5), ".").concat(normalized.substring(5, 8), "/").concat(normalized.substring(8, 12), "-").concat(normalized.substring(12, 14));
}
